import { render, staticRenderFns } from "./TheSettingsPointsCategories.vue?vue&type=template&id=330744d0&"
import script from "./TheSettingsPointsCategories.vue?vue&type=script&lang=js&"
export * from "./TheSettingsPointsCategories.vue?vue&type=script&lang=js&"
import style0 from "./TheSettingsPointsCategories.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports